class CartUpsell extends HTMLElement {
  constructor() {
    super();
    this.cart = document.querySelector("cart-drawer");
    this.variantID = this.dataset.variantId;

    this.querySelector(".upsell-button").addEventListener("click", () =>
      this.addToCart()
    );
  }

  addToCart() {
    const data = {
      items: [
        {
          id: this.variantID, // Replace with actual product variant ID
          quantity: 1,
        },
      ],
      sections: this.cart.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    };

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((response) => {
        console.log("Success:", data);
        // Refresh the cart drawer
        const cartDrawer = document.querySelector("cart-drawer");
        this.cart.renderContents(response);
        this.cart.open();
        // Hide the upsell component
        this.style.display = "none";
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
}

customElements.define("cart-upsell", CartUpsell);



class UpsellTabs extends HTMLElement {
  constructor() {
    super();
    this.tabButtons = this.querySelectorAll('.tab-button');
    this.tabContents = this.querySelectorAll('.tab-content');
    
    this.initializeTabs();
  }

  initializeTabs() {
    this.tabButtons.forEach(button => {
      button.addEventListener('click', () => this.switchTab(button));
    });
  }

  switchTab(selectedButton) {
    const tab = selectedButton.dataset.tab;
    
    // Remove active class from all buttons and contents
    this.tabButtons.forEach(btn => btn.classList.remove('active'));
    this.tabContents.forEach(content => content.classList.remove('active'));
    
    // Add active class to clicked button and corresponding content
    selectedButton.classList.add('active');
    const activeContent = this.querySelector(`.tab-content[data-tab="${tab}"]`);
    if (activeContent) {
      activeContent.classList.add('active');
    }
  }
}

// Define the custom element
customElements.define('upsell-tabs', UpsellTabs);